import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import Layout from 'sushiweb/Layout';
import Breadcrumb from 'sushiweb/Breadcrumb/Breadcrumb';
import H5 from 'sushiweb/Typography/Heading/H5';
import Plus from 'sushiweb/Icons/all/Plus';
import Button from 'sushiweb/Button/Button';
import HorizontalTabs from 'sushiweb/HorizontalTabs/HorizontalTabs';
import { red } from 'sushiweb/tokens/color';
import Spinner from 'sushiweb/Spinner/Spinner';
import {
  BreadCrumbWrapper,
  ConsumptionHeadWrapper,
  DashboardWrapper,
  LayoutContainers,
  SpinnerHolder,
  TabContainer,
  TabHeadWrapper,
  // TabHeadWrapper,
  TabWrapper,
  tabStyle,
} from '../common/styles';
import DetailsWrapper from '../common/components/DetailsWrapper/DetailsWrapper';
import {
  emptyDashboardStateMessage,
  emptyDashboardStateTitle,
} from '../../constants';
import CreateGroupModal from '../common/components/CreateGroupModal';
import UpcomingTopups from './UpcomingTopups';
import PreviousTopups from './PreviousTopups';
import ErrorPage from '../common/components/ErrorPage';
import {
  DASHBOARD,
  REFRESH_LABEL,
  amountBlockedInfo,
  amountDisbursedInfo,
  applicableFlowTypes,
  currentBalanceInfo,
  currentFlowTypeEnum,
  limitConsumedInfo,
  onboardedEmployeeInfoHomePage,
  onboardingPendingInfo,
  ordersPlacedInfo,
} from '../common/components/constants';
import { DASHBOARD_ROUTE } from '../../constants/routes';
import EmptyStateV2 from '../common/components/EmptyStateV2/EmptyStateV2';
import { formatAmountInRupees } from '../../helpers';
import Banner from '../common/components/Banner';
import Consumptions from './Consumptions';
import MonthFilter from './Consumptions/MonthFilter';

const Dashboard = ({
  currentFlow,
  selectedWorkspace,
  getLandingPageDetails,
  landingPageInfo,
  fetchinglandingPage,
  fetchedlandingPage,
  viewOnlyMode,
  getConsumptions,
}) => {
  localStorage.activeIndexDashboard =
    localStorage.activeIndexDashboard !== undefined
      ? Number(localStorage.activeIndexDashboard)
      : 1;
  const isEmployeesAdded = landingPageInfo?.is_employees_added ?? false;
  const [createGroupModalVisible, setCreateGroupModalVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(
    localStorage.activeIndexDashboard !== undefined
      ? Number(localStorage.activeIndexDashboard)
      : 0,
  );
  const [currentMonthSelected, setCurrentMonthSelected] = useState(true);
  const [lastMonthSelected, setLastMonthSelected] = useState(false);
  const handleTabsClick = val => () => {
    setActiveIndex(val);
    localStorage.activeIndexDashboard = Number(val);
  };

  useEffect(() => {
    if (selectedWorkspace && selectedWorkspace.workspace_id) {
      const today = new Date();
      const firstDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        2,
      );
      const lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        1,
      );
      let startDate = firstDayOfMonth.toISOString().split('T')[0];
      let endDate = lastDayOfMonth.toISOString().split('T')[0];
      if (lastMonthSelected) {
        const lastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1,
        );
        const firstDayOfLastMonth = new Date(
          lastMonth.getFullYear(),
          lastMonth.getMonth(),
          2,
        );
        const lastDayOfLastMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          1,
        );
        [startDate] = firstDayOfLastMonth.toISOString().split('T');
        [endDate] = lastDayOfLastMonth.toISOString().split('T');
      }
      getLandingPageDetails({
        workspaceId: selectedWorkspace.workspace_id,
        flowType: currentFlow,
        startDate,
        endDate,
      });
    }
  }, [selectedWorkspace, currentFlow, lastMonthSelected]);

  useEffect(() => {
    if (currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT) {
      const today = new Date();
      const firstDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        2,
      );
      const lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        1,
      );
      let startDate = firstDayOfMonth.toISOString().split('T')[0];
      let endDate = lastDayOfMonth.toISOString().split('T')[0];
      if (lastMonthSelected) {
        const lastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1,
        );
        const firstDayOfLastMonth = new Date(
          lastMonth.getFullYear(),
          lastMonth.getMonth(),
          2,
        );
        const lastDayOfLastMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          1,
        );
        [startDate] = firstDayOfLastMonth.toISOString().split('T');
        [endDate] = lastDayOfLastMonth.toISOString().split('T');
      }
      getConsumptions({ startDate, endDate });
    }
  }, [currentFlow, lastMonthSelected]);

  const refreshPage = () => {
    getLandingPageDetails({
      workspaceId: selectedWorkspace.workspace_id,
      flowType: currentFlow,
    });
  };

  const closeCreateGroupModal = () => {
    setCreateGroupModalVisible(false);
  };

  const handleAddEmployeeClick = () => {
    setCreateGroupModalVisible(true);
  };

  const showSelectedTable = () => {
    if (activeIndex === 0) return <UpcomingTopups />;
    return <PreviousTopups />;
  };

  const ActionComponent = () => {
    return (
      <div>
        <Button
          icon={<Plus />}
          iconAlign='left'
          onClick={() => handleAddEmployeeClick()}
        >
          Add employees
        </Button>
      </div>
    );
  };

  if (fetchinglandingPage) {
    return (
      <DashboardWrapper>
        <BreadCrumbWrapper>
          <Breadcrumb>
            <Breadcrumb.Link
              style={{
                color: 'var(--coolgreycoolgrey-400, #AFB4C0)',
              }}
              linkTo={DASHBOARD_ROUTE}
            >
              Home
            </Breadcrumb.Link>
          </Breadcrumb>
        </BreadCrumbWrapper>
        <TabHeadWrapper>
          <H5>Summary</H5>
        </TabHeadWrapper>
        {currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT && (
          <LayoutContainers>
            <MonthFilter
              currentMonthSelected={currentMonthSelected}
              lastMonthSelected={lastMonthSelected}
              setCurrentMonthSelected={setCurrentMonthSelected}
              setLastMonthSelected={setLastMonthSelected}
            />
          </LayoutContainers>
        )}
        <SpinnerHolder className='center'>
          <Spinner color={red.z_red} size='medium' />
        </SpinnerHolder>
      </DashboardWrapper>
    );
  }

  if (!fetchedlandingPage) {
    return (
      <DashboardWrapper>
        <ErrorPage
          showAction
          actionLabel={REFRESH_LABEL}
          clickAction={refreshPage}
        />
      </DashboardWrapper>
    );
  }

  return !isEmployeesAdded ? (
    <div>
      {createGroupModalVisible && (
        <CreateGroupModal
          currentTab={DASHBOARD}
          closeModal={closeCreateGroupModal}
          isVisible={createGroupModalVisible}
          heading='Create new team'
        />
      )}
      <EmptyStateV2
        state={DASHBOARD}
        title={emptyDashboardStateTitle}
        message={emptyDashboardStateMessage}
        actionComponent={ActionComponent}
      />
    </div>
  ) : (
    <DashboardWrapper>
      {viewOnlyMode && <Banner />}
      <BreadCrumbWrapper>
        <Breadcrumb>
          <Breadcrumb.Link
            style={{
              color: 'var(--coolgreycoolgrey-400, #AFB4C0)',
            }}
            linkTo={DASHBOARD_ROUTE}
          >
            Home
          </Breadcrumb.Link>
        </Breadcrumb>
      </BreadCrumbWrapper>
      <TabHeadWrapper>
        <H5>Summary</H5>
      </TabHeadWrapper>
      {currentFlow === currentFlowTypeEnum.FLOW_TYPE_PPI ? (
        <LayoutContainers>
          <Layout gap={20}>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                showInfoTip
                tooltipDirection='bottomRight'
                tooltipMessage={currentBalanceInfo}
                label='Current balance'
                value={formatAmountInRupees(landingPageInfo.current_balance)}
              />
            </Layout.Item>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                showInfoTip
                tooltipDirection='bottomRight'
                tooltipMessage={amountBlockedInfo}
                label='Amount parked'
                value={formatAmountInRupees(
                  landingPageInfo.amount_blocked ?? 0,
                )}
              />
            </Layout.Item>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                showInfoTip
                tooltipDirection='bottomRight'
                tooltipMessage={amountDisbursedInfo}
                label='Top-ups done this month'
                value={formatAmountInRupees(landingPageInfo.amount_disbursed)}
              />
            </Layout.Item>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                showInfoTip
                tooltipDirection='bottomRight'
                tooltipMessage={onboardedEmployeeInfoHomePage}
                label='Onboarded'
                value={landingPageInfo.active_employees ?? 0}
                subValue={
                  landingPageInfo.active_employees !== 1
                    ? 'employees'
                    : 'employee'
                }
              />
            </Layout.Item>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                showInfoTip
                tooltipDirection='bottomRight'
                tooltipMessage={onboardingPendingInfo}
                label='Onboarding pending'
                value={landingPageInfo.onboarding_pending ?? 0}
                subValue={
                  landingPageInfo.onboarding_pending !== 1
                    ? 'employees'
                    : 'employee'
                }
              />
            </Layout.Item>
          </Layout>
        </LayoutContainers>
      ) : (
        <LayoutContainers>
          <Layout gap={20}>
            {currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT && (
              <Layout.Item colD={12} colT={12} colM={12}>
                <MonthFilter
                  currentMonthSelected={currentMonthSelected}
                  lastMonthSelected={lastMonthSelected}
                  setCurrentMonthSelected={setCurrentMonthSelected}
                  setLastMonthSelected={setLastMonthSelected}
                />
              </Layout.Item>
            )}
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                tooltipMessage={limitConsumedInfo}
                label='Limit consumed'
                value={formatAmountInRupees(landingPageInfo.amount_consumed)}
              />
            </Layout.Item>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                tooltipMessage={ordersPlacedInfo}
                label='Orders placed'
                value={landingPageInfo.orders_placed ?? 0}
              />
            </Layout.Item>
            <Layout.Item colD={4} colT={4} colM={4}>
              <DetailsWrapper
                showInfoTip
                tooltipDirection='bottomRight'
                tooltipMessage={`Employees who placed at least one order ${
                  currentMonthSelected ? 'in this month' : 'last month'
                }`}
                label='Active employees'
                value={landingPageInfo.orders_placing_employees ?? 0}
                subValue={
                  landingPageInfo.orders_placing_employees !== 1
                    ? 'employees'
                    : 'employee'
                }
              />
            </Layout.Item>
          </Layout>
        </LayoutContainers>
      )}
      {currentFlow === currentFlowTypeEnum.FLOW_TYPE_PPI ? (
        <TabWrapper>
          <TabContainer>
            <HorizontalTabs
              style={{ marginBottom: '-4.5px' }}
              alignLinks='left'
              additionalGap='1.8rem'
            >
              <HorizontalTabs.Link
                active={activeIndex === 0}
                onClick={handleTabsClick(0)}
                style={{
                  width: '180px',
                  color:
                    activeIndex === 0
                      ? 'var(--coolgreycoolgrey-800, #414A5D)'
                      : 'var(--coolgreycoolgrey-400, #AFB4C0)',
                  ...tabStyle,
                }}
              >
                Upcoming Top-ups
              </HorizontalTabs.Link>
              <HorizontalTabs.Link
                active={activeIndex === 1}
                onClick={handleTabsClick(1)}
                style={{
                  width: '200px',
                  color:
                    activeIndex === 1
                      ? 'var(--coolgreycoolgrey-800, #414A5D)'
                      : 'var(--coolgreycoolgrey-400, #AFB4C0)',
                  ...tabStyle,
                }}
              >
                Past Top-ups
              </HorizontalTabs.Link>
            </HorizontalTabs>
          </TabContainer>
          {showSelectedTable()}
        </TabWrapper>
      ) : (
        <>
          <ConsumptionHeadWrapper>
            <H5>Consumption details</H5>
          </ConsumptionHeadWrapper>
          <TabWrapper>
            <Consumptions lastMonthSelected={lastMonthSelected} />
          </TabWrapper>
        </>
      )}
    </DashboardWrapper>
  );
};

Dashboard.propTypes = {
  currentFlow: PropTypes.oneOfType(applicableFlowTypes),
  getLandingPageDetails: PropTypes.func,
  landingPageInfo: PropTypes.objectOf(PropTypes.any),
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  fetchinglandingPage: PropTypes.bool,
  fetchedlandingPage: PropTypes.bool,
  viewOnlyMode: PropTypes.bool,
  getConsumptions: PropTypes.func,
};

Dashboard.defaultProps = {
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  getLandingPageDetails: _noop,
  landingPageInfo: {},
  selectedWorkspace: {},
  fetchinglandingPage: true,
  fetchedlandingPage: true,
  viewOnlyMode: false,
  getConsumptions: _noop,
};

export default Dashboard;
